import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";

import Select from "react-select";

import { customStyles, customErrorStyles } from "./selectOptions";

import styles from "./universalModal.module.css";

const UniversalModal = ({
  show,
  onHide,
  onSave,
  onChange = () => {},
  fields,
  initialFieldsData,
  initialData,
  headerName,
  type,
  size = "l",
  stylesFromParent,
  isError = false,
  defaultValueSelector,
}) => {
  const [dataForm, setDataForm] = useState(initialFieldsData);
  const [errors, setErrors] = useState({});
  const [saveKey, setSaveKey] = useState(false);

  const handleChangeSelectSearch = async (event, typeData) => {
    if (!event) return;

    if (typeData === "selectSearch") {
      const newDataForm = { ...dataForm };
      newDataForm[event.key] = event.value;
      onChange(newDataForm);
      setDataForm(newDataForm);
    } else {
      dataForm[event.currentTarget.id] = event.currentTarget.value;
      onChange(event.currentTarget.value);
      setDataForm({ ...dataForm });
    }
    if (saveKey) editErrors("save");
  };

  const handleClose = () => {
    onHide();
  };

  const editErrors = (buttonType) => {
    if (buttonType === "save") {
      const newErrors = {};
      fields.forEach((field) => {
        if (field.required && !dataForm[field.key]) {
          newErrors[field.key] = `Заполните ${field.label}`;
        }
        if (field.hasOwnProperty("pattern") && dataForm[field.key]) {
          if (!field.pattern.value.test(dataForm[field.key])) {
            newErrors[field.key] = field.pattern.message;
          }
        }
      });

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return true;
      } else {
        setErrors({});
        return false;
      }
    } else {
      return false;
    }
  };

  const handleSaveClick = async () => {
    if (editErrors("save")) {
      setSaveKey(true);
      return;
    }
    const shouldContinue = await onSave(dataForm);

    if (typeof shouldContinue === "boolean" && !shouldContinue) {
      return; // Останавливаем выполнение, если onSave вернул false
    }

    if (isError) return;
    handleClose();
  };

  const formatDate = (inputDate) => {
    const parts = inputDate.split(".");
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];

    return `${year}-${month}-${day}`;
  };

  const setValueForSelectSearch = (field) => {
    return field.options.find((item) => item.value === dataForm[field.key]);
  };

  useEffect(() => {
    if (type === "edit") {
      for (const key in initialData) {
        if (Object.prototype.hasOwnProperty.call(initialData, key)) {
          const value = initialData[key];
          if (typeof value === "string" && /^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
            initialData[key] = formatDate(value);
          }
        }
      }
      setDataForm(initialData);
    }
  }, [initialData]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size={size}
      centered>
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>{headerName}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <Form className={stylesFromParent?.container}>
          {fields.map((field) => {
            if (field.type === "selectSearch") {
              return (
                <Form.Group
                  key={field.key}
                  className={stylesFromParent && stylesFromParent[`box-${field.key}`]}>
                  <label className={styles["label"]}>{field.label}</label>
                  {field.required && <span className={styles.red_dot}>*</span>}
                  <Select
                    noOptionsMessage={() => "Нет данных"}
                    defaultValue={defaultValueSelector && type === "edit" && defaultValueSelector}
                    value={setValueForSelectSearch(field)}
                    classNamePrefix="custom-select"
                    styles={!!errors[field.key] ? customErrorStyles : customStyles}
                    onChange={(e) => handleChangeSelectSearch(e, field.type)}
                    placeholder="Выберите"
                    id={field.key}
                    isSearchable={field.isSearchable}
                    isDisabled={field.isDisabled || type === "view"}
                    name={field.key}
                    options={field.options}
                  />
                  {!!errors[field.key] && (
                    <Form.Label className={styles.error}>{errors[field.key]}</Form.Label>
                  )}
                </Form.Group>
              );
            } else {
              return (
                <Form.Group
                  key={field.key}
                  className={stylesFromParent && stylesFromParent[`box-${field.key}`]}>
                  <label className={styles["label"]}>{field.label}</label>
                  {field.required && <span className={styles.red_dot}>*</span>}
                  <input
                    id={field.key}
                    disabled={field.disabled}
                    // isInvalid={!!errors[field.key]}
                    className={`${styles["form-input"]} ${errors[field.key] ? styles["error-border"] : ""}`}
                    placeholder="Введите"
                    type={field.type}
                    value={dataForm[field.key] || ""}
                    onChange={(e) => handleChangeSelectSearch(e)}
                  />
                  {!!errors[field.key] && (
                    <Form.Label className={styles.error}>{errors[field.key]}</Form.Label>
                  )}
                </Form.Group>
              );
            }
          })}
        </Form>
      </Modal.Body>
      <Modal.Footer className={styles["form-footer"]}>
        <button
          className={styles["save-btn"]}
          onClick={handleSaveClick}>
          Сохранить
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UniversalModal;
